import { useQuery } from "@tanstack/react-query";
import { requestCategoryService } from "../services/requestCategory.service";

export const useRequests = (type: string) => {
  return useQuery({
    queryKey: ["requests", type],
    queryFn: () => requestCategoryService.getRequests(type),
    enabled: !!type, // Only fetch if type is provided
  });
};
